import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useSaleCalendar } from '../SaleCalendarContext';
import NoteModal from '../modals/NoteModal';
import BlockModal from '../modals/BlockModal';

export const EventContextMenu = ({ eventContextMenu, handleClose }) => {
  const { submitSaleCalendar, reserveList, setReserveList, customNoteEvents, setCustomNoteEvents, setBlockedResourceDates } = useSaleCalendar();
  const [isInReserveList, setIsInReserveList] = React.useState(false);
  const [openNoteModal, setOpenNoteModal] = React.useState(false);
  const [openBlockModal, setOpenBlockModal] = React.useState(false);

  const handleReserveList = (remove = false) => {
    setReserveList(prev => {
      if (remove) {
        const newReserveList = prev.filter(p => p != parseInt(eventContextMenu.calendarEvent.id));
        submitSaleCalendar(undefined, newReserveList);

        return newReserveList;
      }
      if (prev.find(p => p === parseInt(eventContextMenu.calendarEvent.id))) {

        return [...prev];
      }
      const newReserveList = [...prev, parseInt(eventContextMenu.calendarEvent.id)];
      submitSaleCalendar(undefined, newReserveList);

      return newReserveList;

    });
    handleClose();
  };

  const addNote = (content, color) => {
    console.log(eventContextMenu);
    const id = eventContextMenu.calendarEvent.el.getAttribute('data-date') + eventContextMenu.calendarEvent.resourceId;
    const note = {
      start: eventContextMenu.calendarEvent.el.getAttribute('data-date'),
      end: eventContextMenu.calendarEvent.el.getAttribute('data-date'),
      display: 'background',
      color,
      resourceId: eventContextMenu.calendarEvent.resourceId,
      id,
      noteContent: content,
      type: 'customNote'
    };
    setCustomNoteEvents(prev => {
      if (prev.find(p => p.id === id)) {
        return [...prev];
      }

      return [...prev, note];
    });
    handleClose();
  };

  const removeNote = () => {
    const id = eventContextMenu.calendarEvent.id;
    setCustomNoteEvents(prev => prev.filter(p => p.id !== id));
    handleClose();
  };

  const blockResourceDay = (unlock = false, reason = '') => {
    const id = eventContextMenu.calendarEvent.el.getAttribute('data-date') + eventContextMenu.calendarEvent.el.getAttribute('data-date') + eventContextMenu.calendarEvent.resourceId;
    const newEventObject = {
      start: eventContextMenu.calendarEvent.el.getAttribute('data-date'),
      end: eventContextMenu.calendarEvent.el.getAttribute('data-date'),
      display: 'background',
      color: 'rgba(101, 67, 33, 0.5)',
      resourceId: eventContextMenu.calendarEvent.resourceId,
      id,
      title: reason
    };
    setBlockedResourceDates(prev => {
      const prevIds = prev.map(p => p.id);
      if (!prevIds.includes(id)) {
        return [...prev, newEventObject];
      }

      return [...prev];

    });
    handleClose();
  };

  const unblockResourceDay = () => {
    const id = eventContextMenu.calendarEvent.id;
    setBlockedResourceDates(prev => prev.filter(p => p.id !== id));
    handleClose();
  };

  React.useEffect(() => {
    setIsInReserveList(reserveList.includes(parseInt(eventContextMenu.calendarEvent.id)));
  }, [eventContextMenu]);

  const isOrderEvent = eventContextMenu.calendarEvent?.extendedProps?.identifier;

  return (
    <>
      <Menu
        open={true}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          eventContextMenu.event?.y && eventContextMenu.event?.x
            ? { top: eventContextMenu.event.y, left: eventContextMenu.event.x }
            : undefined
        }
        disableAutoFocusItem
      >
        {isOrderEvent && isInReserveList && <MenuItem onMouseDown={() => handleReserveList(true)}>
        Usuń z listy rezerwowej
        </MenuItem>}
        {isOrderEvent && !isInReserveList && <MenuItem onMouseDown={() => handleReserveList(false)}>
        Dodaj do listy rezerwowej
        </MenuItem>}
        {!isOrderEvent && <MenuItem onClick={e => {
          setOpenBlockModal(true);
        }}>
        Zablokuj ten dzień dla danego terminu
        </MenuItem>}
        {!isOrderEvent && <MenuItem onMouseDown={unblockResourceDay}>
        Odblokuj ten dzień dla danego terminu
        </MenuItem>
        }
        {!isOrderEvent && <MenuItem onMouseDown={() => setOpenNoteModal(true)}>
          Dodaj notatkę
        </MenuItem>}
        {!isOrderEvent && <MenuItem onMouseDown={removeNote}>
          Usuń notatkę
        </MenuItem>}
      </Menu>
      <NoteModal
        open={openNoteModal}
        handleSubmit={addNote}
        handleClose={() => setOpenNoteModal(false)}
      />
      <BlockModal
        open={openBlockModal}
        blockFunction={blockResourceDay}
        handleClose={() => setOpenBlockModal(false)}
      />
    </>
  );
};
